<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.dictCode ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
        <el-form-item label="分类名字" prop="dictName">
          <el-input v-model="dataForm.dictName" placeholder="分类名字"></el-input>
      </el-form-item>
            <el-form-item label="类型" prop="type" >
              <el-radio-group v-model="dataForm.type " @change="getpDict()">
              <el-radio :label="0" >电影</el-radio>
              <el-radio :label="1" >小说</el-radio>
            </el-radio-group>
      </el-form-item>
      <el-form-item label="父标签" prop="pid">
          <el-select v-model="dataForm.pid" placeholder="请选择父分类">
            <el-option
              v-for="item in pDict"
              :key="item.dictCode"
              :label="item.dictName"
              :value="item.dictCode">
            </el-option>
          </el-select>
      </el-form-item>
      <el-form-item label="排序" prop="sorts">
          <el-input v-model="dataForm.sorts" placeholder="排列顺序 ,越小越靠前"></el-input>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      pDict: [],
      dataForm: {
        dictName: '',
        dictCode: '',
        sorts: '',
        type: 0,
        pid: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        dictName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        type: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        pid: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.getpDict();
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        // console.log("reentrantLock" + this.dataForm.id)
        if (this.dataForm.id) {
          this.dataForm.dictCode=this.dataForm.id
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sondict/sondict/${this.dataForm.dictCode}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    getpDict() {
      this.$http.get(`/sondict/sondict/getpDict/${this.dataForm.type}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.pDict = res.data
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.dictCode ? 'post' : 'put']('/sondict/sondict/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
